import React from "react";
import { InformationCircle } from "../../assets/icons";
import { dateShortText } from "../../utils/Date";
import { floatToTime } from "../../utils/Time";
import Tooltip from "../tooltips/Tooltips";

const MissionDetailSidebar = ({
  missionDetail,
  currentWeekMissions,
  getTotalWorkedHours,
  getTotalNightHours,
  getTotalOvertimes,
  /** Même offset que MissionWeekSelector : sous le bandeau intérimaire sticky (px) */
  sidebarStickyTopPx = 0,
}) => {
  if (!missionDetail) return null;

  // On vérifie s'il y a des missions pour cette semaine
  const hasMissionsThisWeek =
    currentWeekMissions && currentWeekMissions.length > 0;

  const topPx = Math.max(sidebarStickyTopPx, 0);
  /** Même espace que MissionWeekSelector sous le bandeau intérimaire sticky */
  const STICKY_GAP_BELOW_HEADER_PX = 10;

  return (
    // Colonne étirée sur toute la hauteur du contenu (comme la colonne gauche) :
    // sinon le parent du sticky est trop court et le bloc ne « colle » pas au scroll.
    <div className="mb-6 flex min-h-0 w-full flex-col lg:mb-8 lg:max-w-[450px] lg:flex-1">
      <div
        className="sticky z-20 flex w-full flex-col gap-6 bg-white pb-4 lg:gap-8"
        style={{
          top: `${topPx + STICKY_GAP_BELOW_HEADER_PX}px`,
        }}
      >
        {/* Information block */}
        <div className="flex w-full h-fit p-4 border border-gray-100 rounded-lg mission-detail-sidebar-infos">
          <div className="flex flex-col gap-8 w-full">
            <div className="font-black">Informations</div>
            <div className="flex flex-col items-start gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-2">
              <div className="shrink-0 font-black">Période</div>
              <div className="text-gray-500 sm:text-right">
                {missionDetail?.dates?.start
                  ? dateShortText(new Date(missionDetail?.dates?.start))
                  : null}{" "}
                {">"}{" "}
                {missionDetail?.dates?.end
                  ? dateShortText(new Date(missionDetail?.dates?.end))
                  : null}
              </div>
            </div>
            <div className="flex flex-col items-start gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-2">
              <Tooltip
                placement="top"
                text="L'intérimaire disposera d'un accès au code jusqu'à cette date."
              >
                <div className="flex items-center gap-1 font-black underline decoration-dashed">
                  <div>Fin de souplesse estimée</div>
                  <div>
                    <InformationCircle wh={16} color="#374151" />
                  </div>
                </div>
              </Tooltip>
              <div className="text-gray-500 sm:text-right">
                {missionDetail?.flexibility?.end
                  ? dateShortText(new Date(missionDetail?.flexibility?.end))
                  : null}
              </div>
            </div>
          </div>
        </div>

        {/* Weekly details block */}
        {hasMissionsThisWeek && (
          <div className="flex w-full h-fit p-4 border border-gray-100 rounded-lg mission-detail-sidebar-weekly-details">
            <div className="flex flex-col gap-8 w-full">
              <div className="font-black">Détail sur la semaine</div>
              <div className="flex flex-col items-start gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-2">
                <div className="font-black">Heures travaillées totales</div>
                <div className="text-gray-500 sm:text-right">
                  {floatToTime(getTotalWorkedHours())}
                </div>
              </div>
              <div className="flex flex-col items-start gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-2">
                <div className="font-black">Heures de nuit totales</div>
                <div className="text-gray-500 sm:text-right">
                  {floatToTime(getTotalNightHours())}
                </div>
              </div>
              <div className="flex flex-col items-start gap-1 text-sm sm:flex-row sm:items-center sm:justify-between sm:gap-2">
                <div className="font-black">Heures supplémentaires</div>
                <div className="text-gray-500 sm:text-right">
                  {floatToTime(getTotalOvertimes())}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MissionDetailSidebar;
